module.exports = __webpack_public_path__ + "bc313dd85b0a58af1f593cfb5b9d81e1.MP3";